import { Component, OnInit } from '@angular/core';
import {InterfaceService} from "./interface.service";

@Component({
    selector: 'app-uploader',
    templateUrl: './uploader.component.html',
    styleUrls: ['./uploader.component.scss'],
    standalone: false
})
export class UploaderComponent implements OnInit {
  isUploading: boolean = false;

  interfaces = [];
  uploadedFiles: any[];
  item: any = {};

  allowedExtensions = ['csv', 'xls', 'xlsx', 'txt', 'json'];

  acceptTypes = {
    csv: '.csv',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    txt: 'text/plain',
    json: 'text/plain'
  }

  config = {
    count: 1,    // upload file count
    type: this.acceptTypes.csv, // allowed upload type
    size_limit: 2 // 2MB upload limit
  }

  constructor(
    private service: InterfaceService
  ) { }

  ngOnInit(): void {
    this.fetchItems();
  }

  fetchItems() {
    this.service.getItems().subscribe((resp:any) => {
      if (resp.error) {
        return !this.service.notiService.open(resp.error);
      }
      if (resp) {
        this.interfaces = resp;

        // Load interface if only 1 exists in list
        if (this.interfaces.length == 1) {
          this.fetchItem(this.interfaces[0].id);
        }
      }
    })
  }

  fetchItem(id) {
    this.service.getItem(id).subscribe((resp: any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error)
      }
      this.item = resp;
      this.checkConfig();
    });
  }

  onInterfaceSelect(item) {
    this.uploadedFiles = [];
    this.item = {};
    if (item.id) {
      this.fetchItem(item.id);
    }
  }

  checkConfig() {
    if (this.item.config) {
      const conf = this.item.config;
      if (conf.size_limit) {
        this.config.size_limit = conf.size_limit
      }
      if (conf.count) {
        this.config.count = conf.count
      }
      if (conf.type) {
        switch (conf.type) {
          case 'csv':
            this.config.type = this.acceptTypes.csv;
            this.allowedExtensions = ['csv'];
            break;
          case 'xls':
            this.config.type = this.acceptTypes.xls;
            this.allowedExtensions = ['xls'];
            break;
          case 'xlsx':
            this.config.type = this.acceptTypes.xlsx;
            this.allowedExtensions = ['xlsx'];
            break;
          case 'txt':
            this.config.type = this.acceptTypes.txt;
            this.allowedExtensions = ['txt'];
            break;

          default:
            console.log("Unknown type:", conf.type);
        }
      }
    }
  }


  /**
   * on file drop handler
   */
  onFileDropped($event) {
    if (!this.validateFiles($event)) {
      return;
    }
    this.prepareFilesList($event);
  }

  validateFiles(files) {
    if (files.length > this.config.count) {
      this.service.notiService.open("Error: Allowed upload file count reached. Limit is: " + this.config.count + " Uploaded: " + files.length);
      return false;
    }
    let size = 0;
    for (let i = 0; i < files.length; i++) {
      size += files[i].size;
    }
    const sizeInMB = size / 1024 / 1024;
    if (sizeInMB > this.config.size_limit) {
      this.service.notiService.open("Error: Allowed upload size limit reached. Limit is: " + this.config.size_limit + "MB. Uploaded: " + sizeInMB + "MB");
      return false;
    }

    let extension = '';
    for (let i = 0; i < files.length; i++) {
      extension = files[i].name.split('.').pop();
      if (!this.allowedExtensions.includes(extension.toLowerCase())) {
        this.service.notiService.open("Error: File extension " + extension + " is not allowed.");
        return false;
      }
    }

    return true;
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    if (!this.validateFiles(files)) {
      return
    }
    this.prepareFilesList(files);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      this.onUploadEvent(item);
    }
  }

  confirmFileDelete(file) {
    this.service.confirmAction(`Are you sure you want to delete this file: ${file.name}`).subscribe((isConfirm: boolean) => {
      if (isConfirm) {
        this.onFileDelete(file);
      }
    })
  }

  onUploadEvent(file) {
    this.isUploading = true;
    if (!file) {
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    this.service.uploadFile(this.item.id, formData).subscribe((resp: any) => {
      if (resp.error) {
        this.service.notiService.open(resp.error);
      }
      if (resp.uploadedFiles) {
        this.service.notiService.open("Successful file upload");
        this.item.uploadedFiles = resp.uploadedFiles;
      }
      this.isUploading = false;
    })
  }

  onFileDelete(file) {
    //this.isUploading = true;
    /*    this.service.deleteFile(this.item.id, file.id).subscribe((resp: any) => {
          if (resp && resp.success) {
            this.item.files = this.util.findAndReplaceItemInArray(file, this.item.files, true);
            this.service.notiService.open('File deleted!');
            this.isUploading = false;
          }
        })*/
  }

}
